import React, { useState, useRef, useEffect } from "react"
import styled from "styled-components"
import { Link } from "gatsby"
import PropTypes from "prop-types"
import MenuPointer from "./menu-slider-navbar/svgs/menu-pointer"

const PopupContainer = styled.div`
  position: absolute;
  top: 0;
  right: ${props => props.$positionRight};
  min-width: 220px;
  width: auto;
  background-color: white;
  border-radius: 10px;
  padding: 12px 0 12px 0;
  font-family: Arial, sans-serif;
  height: max-content;
  transform: translate(0, 32px);
  box-shadow:
    0px 4px 4px 0px rgba(0, 0, 0, 0.25),
    0px -4px 6px -2px rgba(16, 24, 40, 0.03);
  border: 1px solid #f2f4f7;
  transition: all 0.5s ease-in-out;
`

const PopupArrow = styled.div`
  position: absolute;
  top: -13px;
  right: ${props => props.$positionRight};
  transition: all 0.5s ease-in-out;
  display: flex;
  justify-content: center;
  align-items: center;
`

const ListContainer = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  max-width: 220px;
  min-width: ${props => (props.$sideMenu ? "auto" : "220px")};

  max-height: 80vh;

  overflow-y: auto;
  overflow-x: hidden;
`

const ListItem = styled.div`
  display: flex;
  justify-content: space-between;
  text-align: right;
  align-items: center;
  padding: 8px 18px;
  cursor: pointer;
  min-width: 220px;
  color: #272d37;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px;
  letter-spacing: 0.5px;

  &:hover {
    background-color: #fafafa;
  }
`

const ListItemSecondary = styled(Link)`
  color: #272d37;
  font-size: 14px !important;
  font-style: normal;
  font-weight: 400;
  line-height: 21px;
  letter-spacing: 0.5px;
  padding: 6px 18px;
  max-width: 175px;
  text-decoration: none;
  display: flex;
  width: 100%;
  cursor: pointer;
  max-height: 54px;

  &:hover {
    text-decoration: underline;
  }
`

const SecondaryTitle = styled.div`
  color: #374957;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px;
  letter-spacing: 0.5px;
  padding: 6px 16px;
  max-width: 175px;
  white-space: nowrap;
`

const SecondaryLink = styled(Link)`
  color: #272d37;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px;
  letter-spacing: 0.5px;
  padding: 6px 18px;
  max-width: 175px;
  display: block;
  width: 100%;
  text-align: left;
  cursor: pointer;
  &:hover {
    text-decoration: underline;
  }
`

const BrowseButton = styled(Link)`
  text-decoration: none;
  display: block;
  margin: 12px 10px;
  margin-bottom: 0;
  padding: 10px 16px;
  width: auto;
  border: none;
  background-color: #daece4;
  border-radius: 8px;
  cursor: pointer;
  color: #2b4346;
  text-align: center;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 18px;

  &:hover {
    background-color: #c7e4d0;
  }
`

const Arrow = styled.span`
  font-weight: bold;
`

const ListsHolder = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  width: ${props => (props.$hide ? "220px" : "395px")};
  overflow-x: hidden;
  transition: all 0.5s ease-in-out;
`

const Separator = styled.div`
  width: 1px;
  height: auto;
  background: #daece4;
`

const Hide = styled.div`
  display: ${props => (props.$hide ? "none" : "flex")};
`

const LinkWrapper = styled(Link)`
  text-decoration: none;
`

const NavbarMenuPopup = ({ setShowpopup, showPopup, index, items, header }) => {
  const [showSideMenu, setShowSideMenu] = useState(false)
  const [activeSubList, setActiveSubList] = useState([])
  const [activeSubInfo, setActiveSubInfo] = useState({})
  const [isHovered, setIsHovered] = useState(false)
  const timeoutRef = useRef(null)

  const dropdownRef = useRef(null)

  useEffect(() => {
    if (!isHovered) {
      timeoutRef.current = setTimeout(() => {
        if (showPopup === index) {
          setShowpopup(-1)
        }
      }, 2000)
    } else {
      clearTimeout(timeoutRef.current)
    }

    return () => {
      clearTimeout(timeoutRef.current)
    }
  }, [isHovered, showPopup, setShowpopup, index])

  return (
    <PopupContainer
      $hide={!showSideMenu}
      ref={dropdownRef}
      $positionRight={"-101px"}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => {
        setIsHovered(false)
        setShowpopup(-1)
      }}
    >
      <PopupArrow $hide={!showSideMenu} $positionRight={"101px"}>
        <MenuPointer />
      </PopupArrow>
      <ListsHolder $hide={!showSideMenu}>
        <Hide $hide={!showSideMenu}>
          <ListContainer $sideMenu={true}>
            <SecondaryTitle>{activeSubInfo.name}</SecondaryTitle>
            {activeSubList.map(item => (
              <ListItemSecondary to={item.uri || item.url} key={item.name}>
                {item.name}
              </ListItemSecondary>
            ))}
            {activeSubInfo.uri && (
              <SecondaryLink to={activeSubInfo.uri}>
                {`See all of ${activeSubInfo.name}\u00A0>`}
              </SecondaryLink>
            )}
          </ListContainer>
          <Separator />
        </Hide>

        <ListContainer>
          {items.map(item => (
            <LinkWrapper key={item.name} to={item.uri || item.url}>
              <ListItem
                onMouseEnter={() => {
                  setActiveSubInfo({ name: item.name, uri: item.uri })
                  if (item?.items?.length > 0) {
                    setActiveSubList(item.items)
                    setShowSideMenu(true)
                  } else {
                    setActiveSubList([])
                    setShowSideMenu(false)
                  }
                }}
              >
                {item.items.length > 0 ? <Arrow>‹</Arrow> : <Arrow />}{" "}
                {item.name}
              </ListItem>
            </LinkWrapper>
          ))}

          {header?.items?.map(button => (
            <BrowseButton key={button.id} to={button.url}>
              {button.name}
            </BrowseButton>
          ))}
        </ListContainer>
      </ListsHolder>
    </PopupContainer>
  )
}

NavbarMenuPopup.propTypes = {
  setShowpopup: PropTypes.func,
  showPopup: PropTypes.oneOfType([PropTypes.bool, PropTypes.number]),
  index: PropTypes.number,
  items: PropTypes.arrayOf(PropTypes.object),
  header: PropTypes.object,
}

export default NavbarMenuPopup
